import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  ClipboardDocumentCheckIcon,
  MoonIcon,
  BookOpenIcon,
  MapPinIcon,
} from '@heroicons/react/24/outline';

const actions = [
  {
    label: 'Check In',
    description: 'Daily check-in',
    icon: ClipboardDocumentCheckIcon,
    href: '/checkin',
    color: 'bg-teal-500',
  },
  {
    label: 'Nightly Review',
    description: 'Step 10 review',
    icon: MoonIcon,
    href: '/nightly-review',
    color: 'bg-serenity-500',
  },
  {
    label: 'Step Work',
    description: '12 Steps',
    icon: BookOpenIcon,
    href: '/steps',
    color: 'bg-navy-700',
  },
  {
    label: 'Find Meeting',
    description: 'Meetings near you',
    icon: MapPinIcon,
    href: '/meetings',
    color: 'bg-teal-700',
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0 },
};

export function QuickActions() {
  return (
    <motion.div
      className="grid grid-cols-4 gap-3"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {actions.map((action) => (
        <motion.div key={action.label} variants={itemVariants}>
          <Link
            to={action.href}
            className="flex flex-col items-center justify-between p-4 rounded-xl bg-white dark:bg-surface-800 border border-surface-200 dark:border-surface-700 hover:border-surface-300 dark:hover:border-surface-600 transition-all group h-32 sm:h-36"
          >
            <div className={`p-3 rounded-xl ${action.color} text-white group-hover:scale-110 transition-transform`}>
              <action.icon className="w-6 h-6" />
            </div>
            <div className="flex flex-col items-center gap-0.5">
              <span className="text-sm font-medium text-surface-800 dark:text-white text-center">
                {action.label}
              </span>
              <span className="text-xs text-surface-500 dark:text-surface-400 text-center hidden sm:block">
                {action.description}
              </span>
            </div>
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
}
